import { transform } from '@utils/intl_lang'
enum ExamStage {
  info,
  exam,
  result,
  checkCertificate,
  historyScore,
  errorQuestions,
}

// "题干类型 判断(T)/单选(S)/多选(M)/问答题即主观题（A)/图片题（I）/填空题(G)连线提(L) /附件题(F)")
enum QuestionType {
  MULTIPLE = 'M',
  SINGLE = 'S',
  JUDGE = 'T',
  QUESTION_ANSWER = 'A',
  IMAGE = 'I',
  FILL_IN_BLANK = 'G',
  LINE = 'L',
  ATTACMENT = 'F',
  CASE_ANALYSIS = 'C',
  /** 组合单选题 */
  GROUP_SINGLE = 'SG',
  /** 阅读理解题 */
  READ = 'R'
}

/** 试题类型 */
const questionType = {
  // '多选题'
  M: transform('multiple_choice_qus'),
  // '单选题'
  S: transform('single_choice_qus'),
  // '判断题'
  T: transform('judgment_qus'),
  // '主观题'
  A: transform('subjective_qus'),
  // '图片题'
  I: transform('photographs'),
  // '填空题'
  G: transform('completion'),
  // '连线题'
  L: transform('matching'),
  // '附件题'
  F: transform('attachment'),
  // '案例分析'
  C: transform('case_study_questions'),
  // '组合单选题'
  SG: '组合单选题',
  // '阅读理解题'
  R: '阅读理解题',
}

/** 报名状态 */
const enrollStatus = {
  NO_ENROLL: 0,
  CHECKING: 1,
  CHECKIING_PASSED: 2,
  CHECKIING_NOT_PASSED: 3,
}

const statusCode = {
  YES: 1,
  NO: 0,
}

/** 考试结果状态 通过不通过 */
const examResultStatus = {
  PASS: 'Y',
  NO_PASS: 'N',
  MARKED: 'E'
}
/** 考试结果阅卷状态 1-阅卷中,2-阅卷完成 */
const examResultMarking = {
  MARK_ING: 1,
  MARK_END: 2,
}

/** 考试状态 模拟考试/正式考试 */
const typeExam = {
  MOCK: 'M',
  FORMAL: 'F',
  QUIZ: 'C',
}

/** 答案提示是否显示 */
const AnalysisState = {
  YES: 1,
  NO: 0,
}

/** 初始化考试答案 */
const initAnswerList = (arr: any, option = {}) => {
  if (!arr || !arr.length) {
    return []
  }
  const newArr = arr.map((item: any, idx: number) => {
    let questionId = item
    let questionNodesAnswer = null
    if (typeof item === 'object') {
      questionId = item.questionId
    }
    if (item.questionNodeIds || item.questionNodesAnswer) {
      questionNodesAnswer = (item.questionNodeIds || item.questionNodesAnswer).map((i, sub) => ({
        answerList: i.answerList && (i.answerList.length > 0 ? i.answerList : []),
        questionId: i.questionId,
        questionNo: sub + 1,
        ...option
      }))
    }
    return {
      answerList: item.answerList && item.answerList.length > 0 ? item.answerList : [],
      questionId,
      questionNo: idx + 1,
      questionNodesAnswer,
      ...option
    }
  })
  return newArr
}

const isOpenCutScreen = {
  Open: 1,
  Close: 0
}
const ExamType = {
  Course: 1, // 课程
  Exam: 2, // 考试
}


export {
  ExamStage,
  questionType,
  enrollStatus,
  statusCode,
  QuestionType,
  examResultStatus,
  examResultMarking,
  typeExam,
  AnalysisState,
  initAnswerList,
  isOpenCutScreen,
  ExamType,
}
